import { render, staticRenderFns } from "./valuepatinetsatisfaction.vue?vue&type=template&id=5a5fe7ba&"
import script from "./valuepatinetsatisfaction.vue?vue&type=script&lang=js&"
export * from "./valuepatinetsatisfaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports